<template>
  <div class="login">
    <img
      data-cy="logo"
      class="login__img mb-1"
      src="@/assets/images/logo.png"
    />

    <input
      class="login__input"
      data-cy="phone"
      v-model="phone"
      type="text"
      placeholder="0909123456"
    />

    <input
      class="login__input mb-5"
      data-cy="password"
      v-model="password"
      type="password"
      placeholder="Mật khẩu"
    />

    <p class="login__error mb-3" data-cy="error" v-if="isError">
      {{ errorMessage }}
    </p>

    <button
      v-if="!isLoading"
      class="login__login-button"
      data-cy="login-button"
      @click="login"
    >
      Đăng Nhập
    </button>

    <Loading v-else />

    <router-link
      data-cy="register-button"
      to="/register"
      class="login__register-button mt-4"
    >
      Đăng ký tài khoản mới.
    </router-link>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import router from "@/router";
import Loading from "@/components/Loading.vue";
import Auth from "@/controller/auth";

const ERROR_EMPTY = "Vui lòng điền đầy đủ thông tin.";
const ERROR_WRONG_CREDENTIALS = "Số điện thoại hoặc mật khẩu không đúng.";

export default defineComponent({
  name: "Login",
  components: {
    Loading
  },

  setup() {
    const phone = ref("");
    const password = ref("");
    const isError = ref(false);
    const errorMessage = ref("");
    const isLoading = ref(false);

    async function login() {
      if (!phone.value || !password.value) {
        setError(ERROR_EMPTY);
        return;
      }

      isLoading.value = true;

      try {
        await Auth.logIn(phone.value, password.value);
        Auth.setIsAuth(phone.value);
        router.push({ name: "Home" });
      } catch (error) {
        setError(ERROR_WRONG_CREDENTIALS);
      } finally {
        isLoading.value = false;
      }
    }

    function setError(message: string) {
      isError.value = true;
      errorMessage.value = message;
    }

    return {
      phone,
      password,
      isError,
      errorMessage,
      isLoading,
      login
    };
  }
});
</script>

<style lang="scss" scoped>
$input-width: 200px;

.login {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.login__img {
  width: $input-width;
}

.login__input {
  margin-top: 20px;
  padding: 8px 15px;
  width: $input-width;
  border-radius: 25px;
  font-size: 12pt;
}

.login__login-button {
  padding: 10px 10px;
  width: $input-width;
  border-radius: 25px;
  background: $black;
  color: $white;
  font-size: 12pt;
}

.login__register-button {
  color: $black;
}

.login__error {
  color: red;
}
</style>
